import { ArrowLeft } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/Button";
export function NotFoundPage() {
  return (
    <main className="grid min-h-screen place-items-center bg-[#182015] p-5 text-center text-white">
      <div className="w-full max-w-xl rounded-[32px] border border-white/[.07] bg-[#0B0D0E] p-10">
        <p className="eyebrow">404</p>
        <h1 className="mt-4 text-4xl font-semibold tracking-tight">
          That page isn’t here.
        </h1>
        <p className="mt-3 text-sm leading-6 text-[#A0A5A8]">
          The temporary session may have expired, or the link may be outdated.
        </p>
        <Link to="/">
          <Button className="mt-7">
            <ArrowLeft size={17} />
            Back home
          </Button>
        </Link>
      </div>
    </main>
  );
}
